import { RootState } from '../Store';

export const getActiveOrganisationId = (state: RootState): string | null =>
  state.activeOrganisationReducer.organisationId;

export const getIsSwitchingOrganisation = (state: RootState): boolean =>
  state.activeOrganisationReducer.isSwitchingOrganisation;
